import getBaseInfoList from './getBaseInfo.js'
import {getCookie, getLocalStorage, setCookie, setLocalStorage} from '@/utils/base'
/*全局状态*/
const common = {

  namespaced: true,

  /*状态值*/
  state: {
    is_show: false, page: null, base_info: null, show_table: getLocalStorage('show_table') || null
  },

  /*状态值转换*/
  getters: {
    getTset: (state) => (name) => {
      return state.test + name
    },
    getTableShow: (state) => () => {
      let resut = 0
      let base_info = state.base_info
      if (base_info) {
        let show_table = state.show_table
        let key = base_info.username
        if (show_table) {
          resut = show_table[key] || 0
        }
      }
      return resut
    }
  },

  /*改变状态的方法 不可异步*/
  mutations: {
    setState (state, value) {
      state[value.key] = value.val
    },
    setShowTable (state, value) {
      let show_table = state.show_table
      if (!show_table) {
        show_table = {}
      }
      let base_info = state.base_info
      if (base_info) {
        let key = base_info.username
        show_table[key] = value
      }
      setLocalStorage('show_table', show_table)
    }
  },

  /*可异步改变*/
  actions: {
    saveTest (context) {
      context.commit('setState')
    },

    getBaseInfo (context) {
      return new Promise((resolve, reject) => {
        let _data = getCookie('baseInfo')
        if (_data != null) {
          context.commit('setState', {key: 'base_info', val: JSON.parse(_data)})
          resolve(JSON.parse(_data))
        } else {
          getBaseInfoList().then(res => {
            context.commit('setState', {key: 'base_info', val: res})
            setCookie('baseInfo', JSON.stringify(res))
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },

    setTableShow ({commit}, value) {
      return commit('setShowTable', value)
    }
  }
}
export default common



// WEBPACK FOOTER //
// ./src/store/modules/common/index.js